import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { guideMoods } from "@/mocks/content";

export default function Guide() {
  const [activeIdx, setActiveIdx] = useState(0);
  const current = guideMoods[activeIdx];

  return (
    <section id="guide" className="py-16 md:py-24">
      <div className="px-4 md:px-8 max-w-[1280px] mx-auto">
        <Reveal>
          <SectionHeading
            kicker="Guide"
            title="不知道看什么？按当下的心情来挑"
            desc="同一部片子，在不同状态下看会完全不一样。先选一个你现在的心情，再看对应的推荐方向和观影小提示。"
          />
        </Reveal>

        <Reveal>
          <div className="mt-10 md:mt-12 grid grid-cols-1 lg:grid-cols-[300px_1fr] gap-6">
            <div
              className="flex lg:flex-col gap-2 overflow-x-auto lg:overflow-visible no-scrollbar pb-1"
              role="tablist"
              aria-label="按心情选择"
            >
              {guideMoods.map((mood, i) => (
                <button
                  key={mood.key}
                  type="button"
                  role="tab"
                  aria-selected={activeIdx === i}
                  onClick={() => setActiveIdx(i)}
                  className={`whitespace-nowrap lg:whitespace-normal shrink-0 lg:shrink flex items-center gap-3 px-4 py-3.5 rounded-lg font-label text-sm text-left transition-colors cursor-pointer ${
                    activeIdx === i
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-100 text-foreground-700 hover:bg-background-200"
                  }`}
                >
                  <i className={`${mood.icon} text-lg`} aria-hidden="true" />
                  {mood.key}
                </button>
              ))}
            </div>

            <div
              className="bg-background-50 border border-background-200 rounded-xl p-6 md:p-8"
              role="tabpanel"
              aria-label={`${current.key} 的推荐片单`}
            >
              <div className="flex items-center gap-3">
                <span className="w-11 h-11 rounded-lg bg-accent-100 text-accent-700 flex items-center justify-center text-xl">
                  <i className={current.icon} aria-hidden="true" />
                </span>
                <div>
                  <h3 className="font-heading text-xl font-bold text-foreground-950">
                    {current.key}
                  </h3>
                  <p className="font-label text-xs text-foreground-500 mt-1">{current.desc}</p>
                </div>
              </div>

              <div className="mt-6">
                <p className="font-label text-xs tracking-wider text-foreground-500 mb-3">
                  推荐片单
                </p>
                <div className="flex flex-wrap gap-2">
                  {current.picks.map((pick) => (
                    <span
                      key={pick}
                      className="font-heading text-sm font-semibold px-3 py-1.5 rounded-md bg-secondary-100 text-secondary-900"
                    >
                      {pick}
                    </span>
                  ))}
                </div>
              </div>

              <div className="mt-6 pt-6 border-t border-background-200 flex items-start gap-3">
                <i className="ri-lightbulb-line text-accent-600 text-lg mt-0.5" aria-hidden="true" />
                <p className="text-sm leading-relaxed text-foreground-600">
                  <span className="font-label text-foreground-900">观影小提示：</span>
                  {current.tip}
                </p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}